export enum HowToBeKilled {
  Execution = "execution",
  JinroAttack = "jinroAttack",
}
